import { Injectable } from "@nestjs/common";
import { RmPriceList } from "../rm-price-list.entity";
import { RmPriceListDTO } from "./rm-price-list.dto";

@Injectable()
export class RmPriceListAdapter{
    public convertDtoToEntity(RmPriceListDTO:RmPriceListDTO, isUpdate: boolean = false):RmPriceList{
        const rmPriceList = new RmPriceList();
        rmPriceList.rmPriceListId = RmPriceListDTO.rmPriceListId;
        rmPriceList.date = RmPriceListDTO.date;
        rmPriceList.minCount = RmPriceListDTO.minCount;
        rmPriceList.maxCount = RmPriceListDTO.maxCount;
        rmPriceList.price = RmPriceListDTO.price;
        rmPriceList.isActive=RmPriceListDTO.isActive==undefined?true:RmPriceListDTO.isActive;
        if (isUpdate) {
            rmPriceList.updatedUser = RmPriceListDTO.updatedUser;
        } else {
            rmPriceList.isActive = true;
            rmPriceList.createdUser =RmPriceListDTO.createdUser;
        }
        return rmPriceList;
        }
    public convertEntityToDto(rmPriceListObject:RmPriceList):RmPriceListDTO{
        const rmPriceListDTO = new RmPriceListDTO;
        rmPriceListDTO.rmPriceListId = rmPriceListObject.rmPriceListId;
        rmPriceListDTO.date = rmPriceListObject.date;
        rmPriceListDTO.minCount = rmPriceListObject.minCount;
        rmPriceListDTO.maxCount = rmPriceListObject.maxCount;
        rmPriceListDTO.price = rmPriceListObject.price;
        rmPriceListDTO.isActive=rmPriceListObject.isActive;
        rmPriceListDTO.createdAt=rmPriceListObject.createdAt;
        rmPriceListDTO.updatedAt=rmPriceListObject.updatedAt;
        rmPriceListDTO.createdUser=rmPriceListObject.createdUser;
        rmPriceListDTO.updatedUser=rmPriceListObject.updatedUser;
        rmPriceListDTO.versionFlag=rmPriceListObject.versionFlag;

       return rmPriceListDTO;
    }
}